import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Korisnik, Naslov, Uloga } from "../../../index";

const Index = () => {
  const { getValues } = useFormContext();
  const naziv = getValues("operaterPlatforme.naziv.naziv");
  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardContent>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item xs={3} sx={{ textAlign: "center" }}>
            <Uloga />
          </Grid>
          <Grid item xs={6} sx={{ textAlign: "center" }}>
            <Naslov label={naziv || "Naziv (Name)"} />
          </Grid>
          <Grid item xs={3} sx={{ textAlign: "center" }}>
            <Korisnik />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
